"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VoucherItem = exports.TrashIcon = exports.ToPayLine = exports.SummaryWrapper = exports.SummaryTitle = exports.SummaryLine = exports.Root = exports.Line = exports.ContinueWrapper = exports.CashbackAndBonus = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  margin: '0 auto',
  maxWidth: 980,
  [theme.breakpoints.up('lg')]: {
    minWidth: 400,
    maxWidth: 470,
    margin: 0
  }
}));
const SummaryWrapper = exports.SummaryWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  padding: theme.spacing(4, 3),
  background: theme.palette.background.paper,
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 6),
    borderRadius: theme.spacing(2)
  }
}));
const SummaryTitle = exports.SummaryTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(3)
}));
const Line = exports.Line = (0, _mui.styled)('div')({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
});
const SummaryLine = exports.SummaryLine = (0, _mui.styled)(Line)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1),
  '&:last-child': {
    marginBottom: theme.spacing(0)
  }
}));
const VoucherItem = exports.VoucherItem = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));
const TrashIcon = exports.TrashIcon = (0, _mui.styled)(_icons.Trashcan)({
  width: 17,
  cursor: 'pointer'
});
const ToPayLine = exports.ToPayLine = (0, _mui.styled)(Line)(({
  theme
}) => ({
  borderTop: `1px solid ${theme.palette.default.light}`,
  marginTop: theme.spacing(2),
  paddingTop: theme.spacing(2)
}));
const CashbackAndBonus = exports.CashbackAndBonus = (0, _mui.styled)('div')(({
  theme
}) => ({
  paddingTop: theme.spacing(2)
}));
const ContinueWrapper = exports.ContinueWrapper = (0, _mui.styled)('div')(({
  ownerState: {
    isLastStep
  },
  theme
}) => ({
  textAlign: 'center',
  [theme.breakpoints.down('lg')]: {
    ...(!isLastStep && {
      display: 'none'
    })
  }
}));